/**
 * 消息级别展示映射（附件4 §04：送达级别在列表上直接可见）
 * -----------------------------------------------------------------------------
 * 服务端 `MessageInbox` 行只落了 `eventCode`，级别由通知策略表（`notify.policy.ts`
 * 的 DEFAULT_POLICIES）决定。这里按**冻结的 13 类事件码**镜像级别划分 ——
 * 事件码清单固定不得自行增加（`NotifyEventCode` 注释），镜像因此是稳定的；
 * 若服务端调整某事件的级别，此处必须同步（有单测钉住）。
 */
import { NotifyEventCode } from '@enroll/shared';

export type InboxLevel = 'L1' | 'L2' | 'L3';

const EVENT_LEVEL: Record<string, InboxLevel> = {
  // L1 必达级（短信 + 公众号双发）
  [NotifyEventCode.REVIEW_REJECTED]: 'L1',
  [NotifyEventCode.PAYMENT_REMINDER]: 'L1',
  [NotifyEventCode.PAYMENT_RECONCILED]: 'L1',
  [NotifyEventCode.MATERIAL_SUPPLEMENT_REQUIRED]: 'L1',
  [NotifyEventCode.LOGISTICS_ABNORMAL]: 'L1',
  [NotifyEventCode.COURSE_STARTING]: 'L1',
  [NotifyEventCode.EXAM_REMINDER]: 'L1',
  // L2 标准级（公众号优先，可降级短信）
  [NotifyEventCode.REGISTRATION_SUBMITTED]: 'L2',
  [NotifyEventCode.LOGISTICS_SHIPPED]: 'L2',
  [NotifyEventCode.MATERIAL_APPLY_REMINDER]: 'L2',
  [NotifyEventCode.RESULT_PUBLISHED]: 'L2',
  // L3 自助级（不推送，仅留档）
  [NotifyEventCode.INVOICE_ISSUED]: 'L3',
  [NotifyEventCode.RENEWAL_REMINDER]: 'L3',
};

export function inboxLevelOf(eventCode: string): InboxLevel {
  return EVENT_LEVEL[eventCode] ?? 'L3';
}

/** 附件4 §04：黄点＝必达级，绿点＝标准级，灰点＝自助级 */
export const LEVEL_DOT_CLASS: Record<InboxLevel, string> = {
  L1: 'inbox-dot inbox-dot--l1',
  L2: 'inbox-dot inbox-dot--l2',
  L3: 'inbox-dot inbox-dot--l3',
};
